import { normalizeUiMessage } from '../../utils/message-normalizer';
import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController, PopoverController, ToastController } from '@ionic/angular';
import cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'reservationstatus-popover',
  templateUrl: 'itemAddToCartpopup.html',

})

export class itemAddToCartpopup implements OnInit {

  specialRequest:String;
  public items: any;
  public itemsCopy: any;
  commonTextInput: string;


  constructor(public toastController: ToastController, public navParams: NavParams, private popoverController: PopoverController) {
  }

  ngOnInit() {

    this.items = this.navParams.data.items;
    this.specialRequest = this.items.specialRequest
    this.itemsCopy = cloneDeep(this.items);

    if(this.itemsCopy.onlineOrderDetailAttributes)
    {
      for (let index = 0; index < this.items.itemAttributeTypeDisplayPacketList.length; index++) {
        const element = this.items.itemAttributeTypeDisplayPacketList[index];
  
        for (let index = 0; index < element.itemAttributeDisplayPackets.length; index++) {
          const element2 = element.itemAttributeDisplayPackets[index];
  
  
          for (let index = 0; index < this.itemsCopy.onlineOrderDetailAttributes.length; index++) {
            const element1 = this.itemsCopy.onlineOrderDetailAttributes[index];
            if(element1.attributeId == element2.attributeId )
            {
              element2.isSelected = 1;
            }
            
          }
          
        }
        
        
      }
    }
    
    
  }

  plusClicked() {
    this.itemsCopy.itemsQty = this.itemsCopy.itemsQty + 1;
  }
  minusClicked() {
    if (this.itemsCopy.itemsQty > 1) {
      this.itemsCopy.itemsQty = this.itemsCopy.itemsQty - 1;

    } else if (this.itemsCopy.itemsQty == 1) {
      this.itemsCopy.itemsQty = 0;
      this.addToCartClicked();
    } else {
      this.presentToast("Invalid quantity")
    }

  }

  addToCartClicked() {
    let data: any = [];
    data.push("done"); //0
    data.push(this.itemsCopy); //1

    this.itemsCopy.specialRequest = this.specialRequest;
    let cartArray = JSON.parse(localStorage.getItem("cartArray"));
    if (cartArray) {

      let existIndex = -1;
      for (let index = 0; index < cartArray.onlineOrderHeader.onlineOrderDetailItems.length; index++) {
        const element = cartArray.onlineOrderHeader.onlineOrderDetailItems[index];
        if (element.itemsId == this.itemsCopy.itemsId) {
          existIndex = index;
          break;

        }

      }

      if (existIndex != -1) {

        if (this.itemsCopy.itemsQty == 0) {
          this.presentToast("Item removed from cart");

          cartArray.onlineOrderHeader.onlineOrderDetailItems.splice(existIndex, 1);
          localStorage.setItem("cartArray", JSON.stringify(cartArray));
        

        } else {
          cartArray.onlineOrderHeader.onlineOrderDetailItems[existIndex] = this.itemsCopy;
          localStorage.setItem("cartArray", JSON.stringify(cartArray));
        }


      } else {

        if (this.itemsCopy.itemsQty == 0) {
          this.itemsCopy.itemsQty = 1;
          this.presentToast("Item not added in cart");
          return;
        }
        cartArray.onlineOrderHeader.onlineOrderDetailItems.push(this.itemsCopy)
        localStorage.setItem("cartArray", JSON.stringify(cartArray));
      }

      

    } else {

      if (this.itemsCopy.itemsQty == 0) {
        this.itemsCopy.itemsQty = 1;
        this.presentToast("Item not added in cart");
        return;
      }
     
      let onlineOrderDetailItems = []
      onlineOrderDetailItems.push(this.itemsCopy);
      let temp = {
        "merchantId": JSON.parse(localStorage.getItem('selectedBusiness')).accountId.toString(),
        "clientId": localStorage.getItem('deviceId'),
        "locationId": JSON.parse(localStorage.getItem('locationInfo')).id.toString(),
        "echoString": localStorage.getItem('deviceId') + "update order details",
        "schemaName": null,
        "sessionId": null,
        "idOfSessionUsedByPacket": 0,
        "onlineOrderHeader": {
          "id": 0,
          "orderSourceId": 0,
          "comment": null,
          "locationsId": JSON.parse(localStorage.getItem('locationInfo')).id,
          "customerInfo": {
            "firstName": null,
            "lastName": null,
            "phone": null,
            "email": null,
            "customerAddress": null
          },
          "onlineOrderDetailItems": onlineOrderDetailItems,
          "scheduleDateTime": null,
          "thirdPartyId": 0,
          "partnerReferenceNumber": null,
          "orderStatusId": 0,
          "deliveryCharges": null,
          "serviceCharges": null,
          "convenienceCharge": null,
          "futureOrder": false
        }
      };

      localStorage.setItem("cartArray", JSON.stringify(temp));
    }


    this.popoverController.dismiss(data);
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: normalizeUiMessage(msg),
      duration: 2000,
      position: 'middle',
      cssClass: "toast-mess"
    });
    toast.present();
  }

  toggleButton(event, itemAttr,itemAttributeTypeArray) {

    if (event.detail.checked) {
      console.log(event.detail.checked);
      itemAttr.isSelected = '1';

      let itemAttrClone = cloneDeep(itemAttr);

      itemAttrClone.displayName =  itemAttributeTypeArray.displayName + " "+itemAttrClone.displayName
      if(this.itemsCopy.onlineOrderDetailAttributes)
      {
        this.itemsCopy.onlineOrderDetailAttributes.push(itemAttrClone);
      }else
      {
        this.itemsCopy.onlineOrderDetailAttributes = [];
        this.itemsCopy.onlineOrderDetailAttributes.push(itemAttrClone);
      }
      
      
    } else {
      console.log(event.detail.checked);
      itemAttr.isSelected = '0';

      let selectedIndex = -1;
      for (let index = 0; index < this.itemsCopy.onlineOrderDetailAttributes.length; index++) {
        const element = this.itemsCopy.onlineOrderDetailAttributes[index];

        if(element.attributeId == itemAttr.attributeId)
        {
          selectedIndex = index;
          break;
        }
        
      }

      if(selectedIndex != -1)
      {
        this.itemsCopy.onlineOrderDetailAttributes.splice(selectedIndex, 1);
      }
      

    }
    console.log(this.itemsCopy);
    

  }
}